import React from 'react';
import { createBrowserRouter, RouterProvider } from 'react-router-dom';

import HomeScreen from 'screens/HomeScreen';
import DailyScreen from 'screens/DailyScreen';
import PreviousListScreen from 'screens/PreviousListScreen';
import PreviousGameScreen from 'screens/PreviousGameScreen';
import UnlimitedScreen from 'screens/UnlimitedScreen';
import LanguageWrapper from 'components/LanguageWrapper';

const homeScreen = (
  <LanguageWrapper>
    <HomeScreen />
  </LanguageWrapper>
);

const dailyScreen = (
  <LanguageWrapper>
    <DailyScreen />
  </LanguageWrapper>
);

const previousListScreen = (
  <LanguageWrapper>
    <PreviousListScreen />
  </LanguageWrapper>
);

const previousGameScreen = (
  <LanguageWrapper>
    <PreviousGameScreen />
  </LanguageWrapper>
);

const unlimitedScreen = (
  <LanguageWrapper>
    <UnlimitedScreen />
  </LanguageWrapper>
);

const router = createBrowserRouter([
  {
    path: '/',
    element: homeScreen,
  },
  {
    path: '/daily',
    element: dailyScreen,
  },
  {
    path: '/previous',
    element: previousListScreen,
  },
  {
    path: '/previous/:date',
    element: previousGameScreen,
  },
  {
    path: '/unlimited',
    element: unlimitedScreen,
  },
  {
    path: '/:language',
    element: homeScreen,
  },
  {
    path: '/:language/daily',
    element: dailyScreen,
  },
  {
    path: '/:language/previous',
    element: previousListScreen,
  },
  {
    path: '/:language/previous/:date',
    element: previousGameScreen,
  },
  {
    path: '/:language/unlimited',
    element: unlimitedScreen,
  },
]);

function App() {
  return <RouterProvider router={router} />;
}

export default App;
